import { CheckboxInput } from './FormComponents';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const OtherDetails = ({ formData, handleChange, errorData }) => {
  const {bgColor, textColor } = useSelector((state) => state.theam);
  const nvg = useNavigate()
  
  return (
    <div className="card-body pt-0">
 
      <CheckboxInput
        label={
    <>
      I agree to
      <span 
        style={{ color: `#${bgColor}`, cursor: 'pointer' }} 
        onClick={() => { nvg("/useragreement"); }}
      >
        Terms of use

      </span>
{" "}
      and
{" "}

      <span 
        style={{ color: `#${bgColor}`, cursor: 'pointer' }} 
        onClick={() => { nvg("/privacypolicy"); }}
      >
         Privacy Policy
      </span>
    </>
  }
        name="agreeToTerms"
        checked={formData.agreeToTerms}
        onChange={handleChange}
       errorData={errorData.agreeToTerms}
      />
    </div>
)};

export default OtherDetails;